import React, { useState, useRef, useEffect } from "react";
import {
  DownOutlined,
  RightOutlined,
  UpOutlined,
  FilePdfOutlined,
  LeftOutlined,
  UploadOutlined,
  FileExcelFilled,
  PlusOutlined,
  FileWordFilled,
  FileZipFilled,
  FileUnknownFilled,
  FileImageFilled,
  FilePdfFilled,
} from "@ant-design/icons";
import { ReactComponent as Imag1 } from "../../assets/img.svg";
import { ReactComponent as PDFimge } from "../../assets/pdf.svg";
import { ReactComponent as Fileupload } from "../../assets/fileupload.svg";

import styled from "styled-components";
import { ReactComponent as Trash } from "../../assets/Trash_Full.svg";
import { ReactComponent as Edit } from "../../assets/Edit_Pencil_01.svg";
import { ReactComponent as Send } from "../../assets/send.svg";
import { ReactComponent as FaceIcon } from "../../assets/face.svg";
import { ReactComponent as UploadIcon } from "../../assets/upload.svg";
import { ReactComponent as Tick } from "../../assets/tick.svg";
import { useHistory } from "react-router-dom";
import {
  Button,
  Input,
  message,
  Modal,
  Select,
  Upload,
  Card,
  Carousel,
  Row,
  Col,
  DatePicker,
  Form,
  Avatar,
  Spin,
  Typography,
  Radio,
} from "antd";
import moment from "moment";
import {
  getClientid,
  getUserInfo,
  getUserList,
  getMenuList,
  getUserRoleId,
  getLocations,
} from "redux/selectors";
import { connect } from "react-redux";
import { ButtonOutlined } from "reusableComponent/UIButtons";
import { NON_EMPTY_REGEX, STATUS_CODE, VALIDATE_SYMBOL } from "common/Constants";
import { CALL_API } from "common/API";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import COLORS from "common/Colors";
import { get, startCase } from "lodash";
import { convertUTCtoKenyaTimezone } from "utils/Date";

const { Title, Text } = Typography;
dayjs.extend(customParseFormat);

// ─── Shared option lists ────────────────────────────────────────────────────
const CATEGORY_OPTIONS = [
  "Absence from duty without permission",
  "Unwillingness and inability to perform duties",
  "Damage to Company property",
  "Loss of Company property",
  "Unauthorized possession of Company property",
  "Insubordination",
  "Use of abusive language, harassment, or bullying",
  "Gross negligence",
  "Wilful damage to or theft of company property",
  "Fraud or dishonesty in dealing with the company",
  "Theft or misappropriation of Company funds",
  "Under drugs or alcohol during working hours",
  "Noncompliance to standard operating procedure",
];

const ACTION_OPTIONS = [
  "Verbal Warning",
  "First Warning",
  "Second Warning",
  "Third & Final Warning",
  "Show Cause",
  "Suspend",
  "Demotion",
  "Exoneration",
  "Clearance",
  "Termination",
];

const Styleddiv = styled.div`
  .carousel-buttons {
    margin-top: -30px;
    display: flex;
    justify-content: flex-end;
    gap: 8px;
  }
  .breadcrumb {
    display: flex;
    align-items: center;
  }
  .disciplinary-text {
    cursor: pointer;
    font-weight: 400;
    font-size: 16px;
    color: #636980;
  }
  .breadcrumb svg {
    width: 10px;
    height: 10px;
    color: #636980;
    margin-bottom: 10px;
  }
  .view-detail {
    font-weight: 400;
    font-size: 16px;
  }
  .emp-name {
    font-weight: 500;
    font-size: 16px;
    color: #636980;
  }
  .emp-id {
    font-weight: 400;
    font-size: 14px;
    color: #636980;
    margin-bottom: 13px;
  }
  .name-edit-delete {
    display: flex;
    justify-content: space-between;
  }
  .name-edit-delete div {
    display: flex;
    align-items: center;
  }
  .trash-edit-move {
    gap: 10px;
  }
  .two-container {
    display: flex;
    gap: 20px;
  }
  .employee-div {
    display: flex;
    flex-wrap: wrap;
  }
  .line-emp-id {
    color: #e2e2e8;
    margin-bottom: 15px;
  }
  .emp-name-id {
    gap: 10px;
  }
  .id-upload {
    display: flex;
    justify-content: space-between;
  }
  .employee-title {
    width: 30%;
    font-weight: 500;
    font-size: 14px;
    color: #636980;
    text-align: left;
  }
  .employee-total {
    width: 639px;
    border-radius: 8px;
    border: 1px solid #e2e2e8;
    padding: 10px;
  }
  .employee-total1 {
    width: 100%;
    border-radius: 8px;
    border: 1px solid #e2e2e8;
    padding: 10px;
  }
  .timeline-total {
    width: 639px;
    border-radius: 8px;
    border: 1px solid #e2e2e8;
    padding: 10px;
  }
  .employee-id {
    font-weight: 500;
    font-size: 16px;
  }
  .attach-text {
    color: #2d53da;
    border: none;
  }
  .item-value {
    font-weight: 400;
    font-size: 16px;
    color: #1f243b;
  }
  .add-comments {
    font-weight: 500;
    font-size: 16px;
    color: #1f243b;
    padding-top: 20px;
    padding-bottom: 10px;
  }
  .custom-select .ant-select-selector {
    width: 200px;
    height: 34px;
    border-radius: 8px;
    border: 1px solid #2d53da;
  }
  .custom-select .ant-select-placeholder {
    color: #2d53da;
  }
  .comments-input {
    border-radius: 34pc;
  }
  .actions-timeline {
    font-weight: 500;
    font-size: 16px;
  }
  .timeline-name {
    font-weight: 400;
    font-size: 16px;
  }
  .timeline-action {
    font-weight: 400;
    font-size: 16px;
    color: #636980;
  }
  .verbal-warning,
  .first-warning,
  .second-warning {
    color: #119de5;
  }
  .third-final-warning,
  .show-cause {
    color: #f28916;
  }
  .exoneration {
    color: #22ad22;
  }
  .suspend {
    color: #8e2a5e;
  }
  .demotion {
    color: #8e2a5e;
  }
  .clearance {
    color: #22ad22;
  }
  .termination {
    color: #d90325;
  }
  .timeline-date-time {
    font-weight: 400;
    font-size: 14px;
    color: #636980;
  }
  .scrollable-container {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    max-height: 412px;
    overflow-y: auto;
  }
  .face-content {
    display: flex;
    gap: 10px;
  }
  .face-content1 {
    display: flex;
    gap: 10px;
    padding-bottom: 10px;
  }
  .timeline-date-time1 {
    font-weight: 400;
    font-size: 16px;
    color: #636980;
  }
  .for-commented {
    text-decoration: underline;
    color: #2d53da;
    cursor: pointer;
    white-space: nowrap;
  }
  .for-commented1 {
    color: #636980;
    padding: 2.5px;
    padding-top: 6px;
    line-height: 0.5;
    width: 210px;
    border-radius: 8px;
    background-color: #f8d7da;
    display: flex;
    flex-direction: column;
    text-align: right;
    align-items: flex-end;
    margin-top: -48px;
    margin-left: 250px;
    font-size: 12px;
  }
  .datetext {
    color: red;
    font-size: 11px;
  }
  .comment-para {
    font-weight: 400;
    font-size: 14px;
    color: #636980;
  }
  .button-no-border {
    color: #2d53da;
    border: none !important;
    background: transparent;
    box-shadow: none;
    outline: none;
  }
`;

const StyledSelect = styled(Select)`
  .ant-select-selector {
    border-radius: 5px !important;
  }
`;
const StyledInput = styled(Input)`
  border-radius: 5px !important;
`;
const StyledTextArea = styled(Input.TextArea)`
  border-radius: 5px !important;
`;
const StyledButton = styled(Button)`
  width: 130px;
  height: 34px;
  border-radius: 8px;
  border-width: 0.5px;
`;
const StyledModal = styled(Modal)`
  .delete-modal-text {
    font-weight: 400;
    font-size: 16px;
    color: #636980;
  }
  .yes-no-button {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }
  .no-button {
    width: 130px;
    height: 34px;
    border-radius: 8px;
  }
  .yes-button {
    width: 130px;
    height: 34px;
    border-radius: 8px;
    background-color: #2d53da;
    color: #ffffff;
  }
  .success-modal {
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .sent-successfully {
    font-size: 16px;
    font-weight: 400;
  }
  .form-split {
    display: flex;
    gap: 32px;
  }
  .input-width {
    width: 50%;
  }
  .input-width1 {
    width: 24%;
  }
  .input-width2 {
    width: 24%;
    margin-top: 30px;
    margin-left: -20px;
  }
  .mini {
    color: #636980;
    font-weight: 400;
    font-size: 12px;
    margin-top: -22px;
  }
  .form-datepicker {
    border-radius: 5px;
    width: 100%;
  }
  .upload-style {
    width: 190px;
    height: 37px;
    border-radius: 5px;
    background-color: #e3e8fc;
    font-size: 16px;
    font-weight: 400;
    color: #2d53da;
  }
  .upload-icon {
    margin-bottom: 3px;
  }
  .button-style {
    gap: 20px;
  }
  .custom-cancel-button {
    width: 130px;
    height: 34px;
    border-radius: 8px;
    border: 1px solid #2d53da;
    font-size: 16px;
    font-weight: 400;
    color: #2d53da;
    margin-right: 10px;
    background: transparent;
    cursor: pointer;
  }
  .custom-ok-button {
    width: 130px;
    height: 34px;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 400;
    background-color: #2d53da;
    color: #ffffff;
    border: none;
    cursor: pointer;
  }
  .file-item {
    background-color: #f5f5fa;
    padding-left: 10px;
    border-radius: 5px;
    color: black;
    font-size: 16px;
    padding-bottom: 5px;
  }
  .remove-btn {
    font-size: 16px;
    font-weight: 400;
    color: black !important;
  }
  .uploaded-files {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    align-items: center;
  }
  .upload-container {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: nowrap;
  }
  .upload-style1 .anticon-plus {
    position: relative;
    top: -4px;
  }
  .upload-style1 {
    height: 37px;
    border-radius: 5px;
    background-color: #e3e8fc;
    font-size: 16px;
    font-weight: 400;
    color: #2d53da;
  }
`;

const StyledSpinWrapper = styled.div`
  position: relative;
  display: inline-block;

  .spin-overlay {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
  }

  .send-icon {
    opacity: ${(props) => (props.loading ? 0.5 : 1)};
    pointer-events: ${(props) => (props.loading ? "none" : "auto")};
  }
`;

const EmployeeId = [
  { title: "Category", key: 1 },
  { title: "Action", key: 2 },
  { title: "Date of Incident", key: 3 },
  { title: "Number of Appeal", key: 4 },
  { title: "Description", key: 5 },
  { title: "Attachment", key: 6 },
];

const StyledAvatar = styled(Avatar)`
  margin-top: 5px;
  line-height: 40px;
  width: 40px;
  height: 40px;
  background-color: ${COLORS.PRIMARY};
  vertical-align: middle;
`;

function ViewDetailsDisciplinary({
  onBack,
  clientId,
  id,
  getDisData,
  userList,
  userInfo,
  record1,
  category,
  employeeName,
  setSelectedPath,
  menuList,
  userRoleId,
  locationList,
}) {
  const { Option } = Select;

  const [suspendDetails, setSuspendDetails] = useState({
    suspendFromDate: "",
    suspendToDate: "",
    paymentType: "",
  });
  const [record, setRecord] = useState({});
  const [loading, setLoading] = useState(false);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [isDeletedModalOpen, setIsDeletedModalOpen] = useState(false);
  const [isCommentVisible, setIsCommentVisible] = useState("");
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSavedModalOpen, setIsSavedModalOpen] = useState(false);
  const [selectedDisciplinary, setSelectedDisciplinary] = useState(null);
  const [fileList, setFileList] = useState([]);
  const [showLoader, toggleLoader] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [deletedata, setDeletedata] = useState(false);
  const [showmessage, setShowMessage] = useState(false);
  const [selectedAction, setSelectedAction] = useState("");
  const [editData, setEditData] = useState([]);
  const [suspensionDates, setSuspensionDates] = useState([]);
  const [paymentType, setPaymentType] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [fileData, setFileData] = useState([]);
  const [action, setAction] = useState("");
  const [comment, setComment] = useState("");
  const [formData, setFormData] = useState({});

  const Menulist = menuList[userRoleId] || Object.values(menuList)[0];
  const [form] = Form.useForm();

  // FIX: useWatch so the Suspend fields in the edit modal react to form changes
  const editActionValue = Form.useWatch("actions", form);

  const history = useHistory();

  // ── Helpers ─────────────────────────────────────────────────────────────────
  const handleCommentVisibility = (index) => setIsCommentVisible(index);

  const handleDeleteOpen = () => setIsDeleteOpen(true);
  const handleDeleteCancel = () => setIsDeleteOpen(false);
  const handleDeleteConfirm = () => {
    setIsDeleteOpen(false);
    setIsDeletedModalOpen(true);
    setTimeout(() => setIsDeletedModalOpen(false), 2000);
  };

  const handleEditOpen = () => {
    setIsEditModalOpen(true);
    if (Array.isArray(record?.evidence) && record?.evidence?.length > 0) {
      const fileListData = record.evidence.map((fileUrl, index) => ({
        uid: `${index}`,
        name: fileUrl?.fileName,
        status: "done",
        url: fileUrl,
      }));
      const fileDataMapped = record.evidence.map((fileUrl, index) => ({
        ...fileUrl,
        fileName: fileUrl?.fileName,
        contentType: fileUrl?.contentType,
        base64Data: fileUrl?.base64Data,
        uid: `${index}`,
      }));
      setFileList(fileListData);
      setFileData(fileDataMapped);
    } else {
      setFileList([]);
      setFileData([]);
    }
  };

  const handleEditCancel = () => {
    form.resetFields();
    setFileList([]);
    setFileData([]);
    setIsEditModalOpen(false);
  };

  const chunkArray = (array, size) =>
    array?.reduce((acc, _, i) => {
      if (i % size === 0) acc.push(array.slice(i, i + size));
      return acc;
    }, []);

  const carouselRef = useRef();
  const appealChunks = chunkArray(record?.appeals, 2);

  // ── Form submit (edit modal) ─────────────────────────────────────────────────
  const handleFormSubmit = async (values) => {
    try {
      setLoading(true);
      await form.validateFields();
      const filteruser = userList?.filter((item) => item?.userid === values?.employee);
      const cleanedEvidence = fileData?.map((file) => ({
        contentType: file.contentType,
        fileName: file.fileName,
        base64Data: file.base64Data,
      }));
      const payload = {
        clientId: clientId,
        employee: filteruser[0]?.fullname,
        actions: values?.actions,
        category: values.category,
        dateofincident: moment(values.dateofincident).format("YYYY-MM-DD"),
        noofappeal: values.noofappeal,
        description: values.description,
        evidence: cleanedEvidence,
        userId: filteruser[0]?.userid,
        createdByUserName: record?.createdByUserName,
        createdByUserId: record?.createdByUserId,
        employeeId: filteruser[0]?.employeeid,
        suspendtodate: values?.suspendtodate,
        paymenttype: values?.paymenttype,
        suspendfromdate: values?.suspendfromdate,
      };

      const { response, code } = await CALL_API(
        `disciplinary/${clientId}/${record.disciplinaryId}`,
        "patch",
        payload
      );

      if (code === STATUS_CODE.SUCCESS) {
        setIsEditModalOpen(false);
        if (!category && !employeeName) {
          onBack();
          getDisData();
        }
        form.resetFields();
        setFileList([]);
        setFileData([]);
        message.success("Updated Successfully");
        if (category && employeeName) {
          getDetailsData();
          history.push("/disciplinary");
        }
      } else {
        message.error("Failed to update record. Please try again.");
      }
    } catch (error) {
      console.error("API Error:", error);
      message.error("Failed to update record. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // ── Fetch detail ─────────────────────────────────────────────────────────────
  const getDetailsData = async () => {
    try {
      toggleLoader(true);
      const { data, code } = await CALL_API(`disciplinary/${id}`, "get", {});
      if (code === "SUCCESS") {
        setRecord(data[0]);
      } else {
        message.error("Failed to fetch data. Please try again.");
      }
    } catch (error) {
      console.error("API Error:", error);
      message.error("Something went wrong while fetching data.");
    } finally {
      toggleLoader(false);
    }
  };

  useEffect(() => {
    getDetailsData();
  }, [id]);

  // FIX: prepopulate edit form whenever record changes, using correct field names
  useEffect(() => {
    if (record && Object.keys(record).length > 0) {
      form.setFieldsValue({
        ...record,
        employee: record?.userId,
        dateofincident: record.dateofincident ? moment(record.dateofincident) : null,
        suspendfromdate: record?.suspendfromdate ? moment(record.suspendfromdate) : null,
        suspendtodate: record?.suspendtodate ? moment(record.suspendtodate) : null,
      });
    }
  }, [record]);

  // ── Delete ───────────────────────────────────────────────────────────────────
  const deleteDisci = async () => {
    setDeleteLoading(true);
    try {
      const { code } = await CALL_API(
        `disciplinary/${clientId}/${record.disciplinaryId}`,
        "delete"
      );
      if (code === "SUCCESS") {
        onBack();
        getDisData();
        setDeleteLoading(false);
        setShowMessage(false);
        setDeletedata(false);
        setEditData([]);
        message.success("Deleted successfully");
      } else {
        message.error("Failed to Delete");
      }
    } catch (error) {
      console.error("API Error:", error);
    } finally {
      setDeleteLoading(false);
    }
  };

  const getUserNames = (userList) =>
    userList.map((user) => ({ name: user.fullname, userId: user.userid }));
  const userNames = getUserNames(userList);

  const filteruser = userList?.filter((item) => item?.userid === userInfo?.userid);

  // ── Action move (timeline) ───────────────────────────────────────────────────
  const actionMove = async (iscomment, isEdit, values) => {
    setLoading(true);
    try {
      const requestData = {
        disciplinaryId: record?.disciplinaryId,
        insertedby: userInfo?.name,
        comment: iscomment ? comment : "",
        actionmoveon: iscomment
          ? "Commented"
          : isEdit
            ? values?.actions
            : selectedAction,
        profileUrl: filteruser[0]?.profileurl,
      };

      if (selectedAction === "Suspend") {
        requestData.suspendfromdate = suspensionDates?.[0] || null;
        requestData.suspendtodate = suspensionDates?.[1] || null;
        requestData.paymenttype = paymentType || null;
      }

      const { message: msg } = await CALL_API(`disciplinary`, "post", requestData);

      if (msg === "Update Successful") {
        getDetailsData();
        getDisData();
        setComment("");
        setSuspensionDates([]);
        setPaymentType("");
      } else {
        message.error("Update failed");
      }
    } catch (error) {
      console.error("API Error:", error);
      message.error("Something went wrong while updating.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedAction !== "") {
      if (selectedAction === "Suspend") {
        setIsModalVisible(true);
      } else {
        actionMove();
      }
    }
  }, [selectedAction]);

  const handleSelectAction = (value) => {
    setSelectedAction(value);
    getDetailsData();
  };

  const [isSuccessModalVisible, setIsSuccessModalVisible] = useState(false);

  const handleOk = () => {
    actionMove();
    setIsModalVisible(false);
    setIsSuccessModalVisible(true);
    setTimeout(() => setIsSuccessModalVisible(false), 3000);
  };

  const handleCancel = () => setIsModalVisible(false);

  const handleDateChange = (dates) => setSuspensionDates(dates);
  const handlePaymentChange = (e) => setPaymentType(e.target.value);

  // ── File preview modal ───────────────────────────────────────────────────────
  const [isModalOpen1, setIsModalOpen1] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  const [isModalVisible1, setIsModalVisible1] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedFileUrl, setSelectedFileUrl] = useState("");

  const handleOpenModal = (file) => {
    const fileName = file?.fileName?.toLowerCase();
    const fileUrl = file?.fileUrl;
    if (fileName?.endsWith(".xlsx") || fileName?.endsWith(".csv")) {
      const link = document.createElement("a");
      link.href = fileUrl;
      link.download = file?.fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      setSelectedFileUrl(file?.fileUrl);
      setSelectedFile(file);
      setIsModalVisible1(true);
    }
  };

  const handleCloseModal = () => {
    setIsModalVisible1(false);
    setSelectedFileUrl(null);
    setSelectedFile(null);
  };

  // ── Inline file upload (attach file button) ──────────────────────────────────
  const handleFileUpload = async (file) => {
    const maxSizeMB = 25;
    const fileSizeMB = file.size / (1024 * 1024);

    if (file.type === "video/mp4") {
      message.error("MP4 video files are not allowed.");
      return;
    }
    if (fileSizeMB > maxSizeMB) {
      message.error("File size must be less than 25MB");
      return;
    }

    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = async () => {
      const base64Data = reader.result.split(",")[1];

      const existingEvidence = (record.evidence || []).map((f) => ({
        contentType: f.contentType,
        fileName: f.fileName,
        base64Data: f.base64Data,
      }));

      const fileLists = [
        ...existingEvidence,
        { base64Data, contentType: file.type, fileName: file.name },
      ];

      setFileList((prev) => [
        ...prev,
        { uid: file.uid, name: file.name, status: "done", url: reader.result },
      ]);

      const payload = { ...record, clientId, evidence: fileLists };

      try {
        const { response, code } = await CALL_API(
          `disciplinary/${clientId}/${record.disciplinaryId}`,
          "patch",
          payload
        );
        if (code === STATUS_CODE.SUCCESS) {
          message.success("File uploaded and record updated successfully");
          getDetailsData();
        } else {
          message.error("Failed to update record. Please try again.");
        }
      } catch (error) {
        console.error("API Error:", error);
        message.error("Failed to update record. Please try again.");
      }
    };

    reader.onerror = () => message.error("File read error. Please try again.");
  };

  const handleRemove = (file) => {
    setFileList((prev) => prev.filter((item) => item.uid !== file.uid));
    setFileData((prev) => prev.filter((item) => item.uid !== file.uid));
  };

  const createdUser = (userId) => userList?.find((user) => user?.userid === userId);

  // ── Render ───────────────────────────────────────────────────────────────────
  return (
    <>
      <Styleddiv>
        <div>
          {/* Breadcrumb */}
          {!category && !employeeName && (
            <div className="breadcrumb">
              <p className="disciplinary-text" onClick={onBack}>Disciplinary</p>
              &nbsp;<RightOutlined />&nbsp;
              <p className="view-detail" onClick={onBack}>View Detail</p>
            </div>
          )}
          {category && employeeName && (
            <div className="breadcrumb">
              <p className="disciplinary-text" onClick={() => history.goBack()}>{category}</p>
              &nbsp;
              <RightOutlined style={{ fontSize: "20px", position: "relative", top: "-1px" }} />
              &nbsp;
              <p className="disciplinary-text" onClick={() => setSelectedPath(false)}>View Detail</p>
              &nbsp;
              <RightOutlined style={{ fontSize: "20px", position: "relative", top: "-2px" }} />
              &nbsp;
              <p className="view-detail">{employeeName}</p>
            </div>
          )}

          {/* Name / edit / delete / move-to row */}
          <div className="name-edit-delete">
            <div className="emp-name-id">
              <p className="emp-name">{record?.employee}</p>
              <span className="line-emp-id">|</span>
              <span className="emp-id">{record?.employeeId}</span>
            </div>
            <div className="trash-edit-move">
              {Menulist?.find(
                (item) => item?.key === "mydisciplinary" && item?.permission.delete
              ) && (
                  <Trash
                    onClick={handleDeleteOpen}
                    style={{ cursor: "pointer", backgroundColor: "#C2FAE5" }}
                  />
                )}
              {Menulist?.find(
                (item) => item?.key === "mydisciplinary" && item?.permission.edit
              ) && (
                  <Edit
                    onClick={(event) => {
                      event.stopPropagation();
                      // FIX: set form values correctly before opening edit modal
                      form.setFieldsValue({
                        ...record,
                        employee: record?.userId,
                        dateofincident: record.dateofincident
                          ? moment(record.dateofincident)
                          : null,
                        suspendfromdate: record?.suspendfromdate
                          ? moment(record.suspendfromdate)
                          : null,
                        suspendtodate: record?.suspendtodate
                          ? moment(record.suspendtodate)
                          : null,
                      });
                      handleEditOpen(true);
                    }}
                    style={{ cursor: "pointer" }}
                  />
                )}

              {history.location.pathname !== "/mydisciplinary" && (
                <Select
                  placeholder="Move to"
                  className="custom-select"
                  onChange={(value) => handleSelectAction(value)}
                >
                  {ACTION_OPTIONS.filter(
                    (option) => option.toLowerCase() !== record.actions?.toLowerCase()
                  ).map((option) => (
                    <Option key={option} value={option}>
                      {option}
                    </Option>
                  ))}
                </Select>
              )}

              {/* Suspension detail modal (triggered by "Move to → Suspend") */}
              <Modal
                title="Suspension Details"
                open={isModalVisible}
                onOk={handleOk}
                onCancel={handleCancel}
                width={570}
                height={312}
                footer={[
                  <StyledButton key="cancel" onClick={handleCancel}>Cancel</StyledButton>,
                  <StyledButton key="submit" type="primary" onClick={handleOk}>Suspend</StyledButton>,
                ]}
              >
                <p style={{ fontWeight: "500", fontSize: "14px" }}>Suspension Duration</p>
                <div style={{ display: "flex", gap: "16px" }}>
                  <DatePicker
                    value={suspensionDates?.[0]}
                    onChange={(date) => handleDateChange([date, suspensionDates?.[1]])}
                    format="DD MMMM, YYYY"
                    style={{ width: "100%" }}
                  />
                  <DatePicker
                    value={suspensionDates?.[1]}
                    onChange={(date) => handleDateChange([suspensionDates?.[0], date])}
                    format="DD MMMM, YYYY"
                    style={{ width: "100%" }}
                  />
                </div>
                <p style={{ fontWeight: "500", fontSize: "14px", marginTop: "10px" }}>Payment Type</p>
                <Radio.Group onChange={handlePaymentChange} value={paymentType}>
                  <Radio value="With Pay">With Pay</Radio>
                  <Radio value="Without Pay">Without Pay</Radio>
                </Radio.Group>
              </Modal>
            </div>
          </div>
          <br />

          {/* Main content: detail card + timeline */}
          <div className="two-container">
            {/* Detail card */}
            <div className="employee-total">
              <div className="id-upload">
                <div className="employee-id">
                  <span className="employee-title">Disciplinary ID: </span>
                  {record.disciplinaryId}
                </div>
                <div>
                  <Upload customRequest={({ file }) => handleFileUpload(file)} showUploadList={false}>
                    <button className="button-no-border">
                      <UploadIcon className="upload-icon" /> Attach File
                    </button>
                  </Upload>
                </div>
              </div>
              <br />
              <div>
                {EmployeeId.map((item) => (
                  <div
                    key={item.key}
                    className={item.title === "Attachment" ? "attachment-div" : "employee-div"}
                  >
                    <p className="employee-title">{item.title}</p>
                    <p className="item-value">
                      {item.title === "Category" ? (
                        record.category || "---"
                      ) : item.title === "Action" ? (
                        <span
                          style={{
                            color: record.actions?.toLowerCase().includes("first") ||
                              record.actions?.toLowerCase().includes("second") ||
                              record.actions?.toLowerCase().includes("verbal")
                              ? "#119DE5"
                              : record.actions?.toLowerCase().includes("third") ||
                                record.actions?.toLowerCase().includes("show cause")
                                ? "#F28916"
                                : record.actions?.toLowerCase().includes("suspend") ||
                                  record.actions?.toLowerCase().includes("demotion")
                                  ? "#8E2A5E"
                                  : record.actions?.toLowerCase().includes("exoneration") ||
                                    record.actions?.toLowerCase().includes("clearance")
                                    ? "#22AD22"
                                    : record.actions?.toLowerCase().includes("termination")
                                      ? "#D90325"
                                      : "black",
                          }}
                        >
                          {record.actions || "---"}
                        </span>
                      ) : item.title === "Date of Incident" ? (
                        moment(record.dateofincident, "YYYY-MM-DD").format("Do MMMM YYYY") || "---"
                      ) : item.title === "Number of Appeal" ? (
                        record.noofappeal || "---"
                      ) : item.title === "Description" ? (
                        record.description || "---"
                      ) : item.title === "Attachment" ? (
                        record.evidence && record.evidence.length > 0 ? (
                          <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
                            {record.evidence.map((fileUrl, index) => {
                              const isImage = /\.(jpg|jpeg|png|gif)$/i.test(fileUrl?.fileName);
                              const isPdf = /\.pdf$/i.test(fileUrl?.fileName);
                              const isExcel = /\.(xls|xlsx|csv)$/i.test(fileUrl?.fileName);
                              const isZip = /\.zip$/i.test(fileUrl?.fileName);
                              const isDoc = /\.(doc|docx)$/i.test(fileUrl?.fileName);

                              const fileIcon = isImage ? (
                                <FileImageFilled style={{ fontSize: 18, color: "#1890ff" }} />
                              ) : isPdf ? (
                                <FilePdfFilled style={{ fontSize: 18, color: "#d32029" }} />
                              ) : isExcel ? (
                                <FileExcelFilled style={{ color: "green", fontSize: "20px" }} />
                              ) : isDoc ? (
                                <FileWordFilled style={{ color: "#2B579A", fontSize: "20px" }} />
                              ) : isZip ? (
                                <FileZipFilled style={{ color: "#F4A100", fontSize: "20px" }} />
                              ) : (
                                <FileUnknownFilled style={{ color: "#8c8c8c", fontSize: "20px" }} />
                              );

                              return (
                                <button
                                  key={index}
                                  style={{
                                    boxShadow: "1px 1px 5px rgba(0,0,0,0.2)",
                                    padding: "5px 8px",
                                    border: "none",
                                    borderRadius: "5px",
                                    backgroundColor: "white",
                                    cursor: "pointer",
                                    width: "200px",
                                    textAlign: "left",
                                    display: "inline-block",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                  }}
                                  onClick={() => handleOpenModal(fileUrl)}
                                >
                                  {fileIcon}&nbsp;&nbsp;{fileUrl?.fileName}
                                </button>
                              );
                            })}
                          </div>
                        ) : (
                          "---"
                        )
                      ) : null}
                    </p>
                  </div>
                ))}
              </div>
            </div>

            {/* Timeline */}
            <div className="timeline-total">
              <div className="actions-timeline">Actions' Timeline</div>
              <br />
              <div className="scrollable-container">
                {/* Created entry */}
                <div className="face-content1">
                  <div>
                    {!createdUser(record?.createdByUserId)?.profileurl ||
                      createdUser(record?.createdByUserId)?.profileurl.trim() === "" ? (
                      <StyledAvatar size="default">
                        {startCase(record?.name?.charAt(0) || "N")}
                      </StyledAvatar>
                    ) : (
                      <StyledAvatar
                        src={createdUser(record?.createdByUserId)?.profileurl}
                        size="default"
                      />
                    )}
                  </div>
                  <div className="timeline-item">
                    <span className="timeline-name">{record?.createdByUserName};&nbsp;</span>
                    <span className="timeline-date-time1">created the ticket</span>
                    <br />
                    <span className="timeline-date-time">
                      {record?.insertedAt ? convertUTCtoKenyaTimezone(record.insertedAt) : "-"}
                    </span>
                  </div>
                </div>

                {/* Action timeline items */}
                {record?.actiontimeline?.map((item, index) => (
                  <div className="face-content" key={index}>
                    <div>
                      {item?.profileUrl === "" ? (
                        <StyledAvatar size="default">
                          {startCase(get(userInfo, "name", "").charAt(0))}
                        </StyledAvatar>
                      ) : (
                        <StyledAvatar src={item?.profileUrl} size="default" />
                      )}
                    </div>
                    <div className="timeline-item" style={{ width: "100%" }}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          width: "100%",
                        }}
                      >
                        <div>
                          <span className="timeline-name">{item?.insertedby};&nbsp;</span>
                          {item.actionmoveon !== "Commented" &&
                            item.actionmoveon !== "Update the ticket" && (
                              <span className="timeline-action">Moved to </span>
                            )}
                          <span
                            className={`timeline-action ${item.actionmoveon === "Verbal Warning" ||
                              item.actionmoveon === "First Warning" ||
                              item.actionmoveon === "Second Warning"
                              ? "verbal-warning first-warning second-warning"
                              : item.actionmoveon === "Third & Final Warning" ||
                                item.actionmoveon === "Show Cause"
                                ? "third-final-warning show-cause"
                                : item.actionmoveon === "Exoneration"
                                  ? "exoneration"
                                  : item.actionmoveon === "Suspend"
                                    ? "suspend"
                                    : item.actionmoveon === "Demotion"
                                      ? "demotion"
                                      : item.actionmoveon === "Clearance"
                                        ? "clearance"
                                        : item.actionmoveon === "Termination"
                                          ? "termination"
                                          : ""
                              }`}
                          >
                            {item?.actionmoveon}
                          </span>
                        </div>
                        {item.actionmoveon === "Commented" && (
                          <span
                            className="for-commented"
                            onClick={() =>
                              isCommentVisible === index
                                ? handleCommentVisibility("")
                                : handleCommentVisibility(index)
                            }
                          >
                            {isCommentVisible === index ? (
                              <>Close Comment <UpOutlined /></>
                            ) : (
                              <>View Comment <DownOutlined /></>
                            )}
                          </span>
                        )}
                      </div>

                      <span className="timeline-date-time">
                        {convertUTCtoKenyaTimezone(item?.insertedAt)}
                      </span>

                      {item.actionmoveon === "Suspend" && (
                        <div className="for-commented1">
                          <p>
                            Duration:
                            <span className="datetext">
                              {" "}
                              {moment(item.suspendfromdate).format("Do MMM YYYY")} -{" "}
                              {moment(item.suspendtodate).format("Do MMM YYYY")}
                            </span>
                          </p>
                          <p>
                            Payment Type:
                            <span className="datetext"> {item.paymenttype}</span>
                          </p>
                        </div>
                      )}

                      {item.actionmoveon === "Commented" && isCommentVisible === index && (
                        <div style={{ marginTop: "8px" }}>
                          <p className="comment-para">{item?.comment}</p>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <br />

          {/* Appeals carousel */}
          {record?.appeals?.length > 0 && (
            <div className="employee-total1">
              <Card
                title={
                  <div className="header-container">
                    <span>Appeals ({record?.appeals?.length})</span>
                    <div className="carousel-buttons">
                      <Button icon={<LeftOutlined />} onClick={() => carouselRef.current.prev()} />
                      <Button icon={<RightOutlined />} onClick={() => carouselRef.current.next()} />
                    </div>
                  </div>
                }
                bordered={false}
              >
                <Carousel ref={carouselRef}>
                  {appealChunks?.map((chunk, index) => (
                    <div key={index}>
                      <Row gutter={[16, 16]} justify="center">
                        {chunk.map((appeal) => (
                          <Col xs={24} sm={12} key={appeal?.disciplinaryId}>
                            <Card bordered className="pt-2">
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  color: "#636980",
                                  alignItems: "center",
                                  width: "100%",
                                }}
                              >
                                <Title level={5} style={{ display: "inline", marginRight: 0, marginBottom: 0 }}>
                                  Description
                                </Title>
                                <span style={{ fontWeight: 400, fontSize: 14, color: "#636980" }}>
                                  {appeal.createdAt ? convertUTCtoKenyaTimezone(appeal.createdAt) : ""}
                                </span>
                              </div>
                              <Text>{appeal?.appealText}</Text>
                              <Title level={5} style={{ marginTop: 16 }}>Attachment</Title>
                              {appeal?.appealFiles?.map((item, index) => (
                                <ButtonOutlined
                                  key={item.uid || index}
                                  onClick={() => handleOpenModal(item)}
                                  style={{
                                    marginRight: "10px",
                                    padding: "6px 12px",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: "8px",
                                    overflow: "hidden",
                                  }}
                                >
                                  <span style={{ display: "flex", alignItems: "center", justifyContent: "center", width: 18, height: 18, flexShrink: 0 }}>
                                    <Fileupload style={{ fontSize: 16 }} />
                                  </span>
                                  <span style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: 160, lineHeight: "16px" }}>
                                    {item.fileName || "-"}
                                  </span>
                                </ButtonOutlined>
                              ))}
                            </Card>
                          </Col>
                        ))}
                        {chunk.length % 2 !== 0 && (
                          <Col xs={24} sm={12}>
                            <Card bordered className="pt-2" style={{ visibility: "hidden" }} />
                          </Col>
                        )}
                      </Row>
                    </div>
                  ))}
                </Carousel>
              </Card>
            </div>
          )}

          {/* Add comment */}
          <div>
            <div className="add-comments">Add Comments</div>
            <Input
              placeholder="Type here..."
              className="comments-input"
              value={comment}
              suffix={
                <StyledSpinWrapper loading={loading}>
                  {loading && <Spin className="spin-overlay" size="small" />}
                  <Send
                    className="send-icon"
                    onClick={() => { if (comment.trim()) actionMove(true); }}
                    style={{
                      cursor: comment.trim() ? "pointer" : "not-allowed",
                      color: comment.trim() ? "#C2FAE5" : "#bfbfbf",
                      transition: "color 0.2s ease",
                    }}
                  />
                </StyledSpinWrapper>
              }
              onChange={(e) => setComment(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter" && comment.trim() && !loading) actionMove(true);
              }}
            />
          </div>
        </div>

        {/* ── Delete confirm modal ──────────────────────────────────────────── */}
        <StyledModal
          width={470}
          height={140}
          footer={false}
          closable={false}
          open={isDeleteOpen}
          onCancel={handleDeleteCancel}
          style={{ marginTop: "100px" }}
        >
          <p className="delete-modal-text">
            Are you sure you want to delete this disciplinary ticket?
          </p>
          <br />
          <div className="yes-no-button">
            <Button onClick={handleDeleteCancel} type="secondary" className="no-button">No</Button>
            <Button
              loading={deleteLoading}
              type="primary"
              onClick={async () => {
                await deleteDisci();
                handleDeleteConfirm();
              }}
              className="yes-button"
            >
              Yes
            </Button>
          </div>
        </StyledModal>

        {/* ── Edit modal ────────────────────────────────────────────────────── */}
        <StyledModal
          width={950}
          height={120}
          style={{ top: "10px" }}
          title="Editing Disciplinary"
          open={isEditModalOpen}
          onCancel={handleEditCancel}
          footer={false}
        >
          <Form
            layout="vertical"
            name="disciplinary-form"
            form={form}
            onFinish={handleFormSubmit}
            onValuesChange={(value, allvalue) => setFormData(allvalue)}
          >
            {/* Employee */}
            <Form.Item
              label="Employee"
              name="employee"
              rules={[{ required: true, message: "Please select employee" }]}
            >
              <StyledSelect placeholder="Select employee" optionLabelProp="label">
                {userNames.map((item, index) => (
                  <Select.Option key={index} value={item.userId} label={item.name}>
                    {item.name}
                  </Select.Option>
                ))}
              </StyledSelect>
            </Form.Item>

            {/* Category + Action */}
            <div className="form-split">
              <div className="input-width">
                <Form.Item
                  label="Category"
                  name="category"
                  rules={[{ required: true, message: "Please select category" }]}
                >
                  {/* FIX: uses shared CATEGORY_OPTIONS — consistent values */}
                  <StyledSelect placeholder="Select category">
                    {CATEGORY_OPTIONS.map((cat) => (
                      <Select.Option key={cat} value={cat}>{cat}</Select.Option>
                    ))}
                  </StyledSelect>
                </Form.Item>
              </div>
              <div className="input-width">
                <Form.Item
                  label="Action"
                  name="actions"
                  rules={[{ required: true, message: "Please select action" }]}
                >
                  {/* FIX: neutral placeholder + shared ACTION_OPTIONS
                      FIX: "Third & Final Warning" had a leading space in the old value */}
                  <StyledSelect placeholder="Select action">
                    {ACTION_OPTIONS.map((action) => (
                      <Select.Option key={action} value={action}>{action}</Select.Option>
                    ))}
                  </StyledSelect>
                </Form.Item>
              </div>
            </div>

            {/* Date + Appeals */}
            <div className="form-split">
              <div className="input-width">
                <Form.Item
                  label="Date of Incident"
                  name="dateofincident"
                  rules={[{ required: true, message: "Please select date of incident" }]}
                >
                  <DatePicker className="form-datepicker" format="D MMMM YYYY" placeholder="Select a date" />
                </Form.Item>
              </div>
              <div className="input-width">
                <Form.Item
                  label="Number of Appeals the employee can have"
                  name="noofappeal"
                  rules={[{ required: true, message: "Please enter Number of Appeals" }]}
                >
                  <StyledInput
                    placeholder="Number of Appeals"
                    maxLength={1}
                    onKeyDown={(e) => {
                      if (!/^[1-9]$/.test(e.key) && e.key !== "Backspace") e.preventDefault();
                    }}
                  />
                </Form.Item>
                <p className="mini">Minimum of 1 Appeal not less than that</p>
              </div>
            </div>

            {/* FIX: suspension fields driven by useWatch — shows correctly on edit */}
            {editActionValue === "Suspend" && (
              <div className="form-split">
                <div className="input-width1">
                  <Form.Item
                    label="Suspension Duration"
                    name="suspendfromdate"
                    rules={[{ required: true, message: "Please select suspension start date" }]}
                  >
                    <DatePicker className="form-datepicker" format="Do MMMM, YYYY" placeholder="From date" />
                  </Form.Item>
                </div>
                <div className="input-width2">
                  <Form.Item
                    label=""
                    name="suspendtodate"
                    rules={[{ required: true, message: "Please select suspension end date" }]}
                  >
                    <DatePicker className="form-datepicker" format="Do MMMM, YYYY" placeholder="To date" />
                  </Form.Item>
                </div>
                <div className="input-width">
                  <Form.Item label="Payment Type" name="paymenttype">
                    <Radio.Group>
                      <Radio value="With Pay">With Pay</Radio>
                      <Radio value="Without Pay">Without Pay</Radio>
                    </Radio.Group>
                  </Form.Item>
                </div>
              </div>
            )}

            {/* Description */}
            <Form.Item label="Description" name="description">
              <StyledTextArea placeholder="Description" rows={2} />
            </Form.Item>
            <p className="mini">Maximum 250 Characters</p>

            {/* Attachment */}
            <Form.Item label="Attachment (Optional)" name="attachment">
              <div className="upload-container">
                {fileList.length > 0 && (
                  <div className="uploaded-files">
                    {fileList.map((file) => (
                      <span key={file.uid} className="file-item">
                        <span style={{ width: "220px", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}>
                          {file.name}
                        </span>
                        <Button type="text" className="remove-btn" onClick={() => handleRemove(file)}>
                          &times;
                        </Button>
                      </span>
                    ))}
                  </div>
                )}
                <Upload
                  fileList={fileList}
                  customRequest={({ file, onSuccess, onError }) => {
                    const maxSizeMB = 25;
                    const fileSizeMB = file.size / (1024 * 1024);

                    if (file.type === "video/mp4") {
                      message.error("MP4 video files are not allowed.");
                      onError?.("MP4 files are not allowed.");
                      return;
                    }
                    if (fileSizeMB > maxSizeMB) {
                      message.error("File size must be less than 25MB");
                      onError?.("File size exceeds 25MB");
                      return;
                    }

                    const reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = () => {
                      const base64Data = reader.result.split(",")[1];
                      onSuccess();
                      setFileData((prev) => [
                        ...prev,
                        { uid: file.uid, base64Data, contentType: file.type, fileName: file.name },
                      ]);
                      setFileList((prev) => [
                        ...prev,
                        { uid: file.uid, name: file.name, status: "done", url: reader.result },
                      ]);
                    };
                    reader.onerror = (error) => {
                      console.error("File read error:", error);
                      message.error("File read error");
                      onError?.("File read error");
                    };
                  }}
                  onRemove={(file) => {
                    setFileList((prev) => prev.filter((item) => item.uid !== file.uid));
                    setFileData((prev) => prev.filter((item) => item.uid !== file.uid));
                  }}
                  showUploadList={false}
                >
                  {fileList.length === 0 ? (
                    <Button className="upload-style">
                      <UploadOutlined /> &nbsp; Add Attachment
                    </Button>
                  ) : (
                    <Button className="upload-style1"><PlusOutlined /></Button>
                  )}
                </Upload>
              </div>
            </Form.Item>

            {/* Footer buttons — FIX: use proper Button with htmlType="submit" */}
            <div className="d-flex justify-content-end gap-2">
              <button className="custom-cancel-button" type="button" onClick={handleEditCancel}>
                Cancel
              </button>
              <button
                className={`custom-ok-button ${loading ? "loading" : ""}`}
                type="submit"
              >
                {loading ? "Saving..." : "Save Changes"}
              </button>
            </div>
          </Form>
        </StyledModal>

        {/* ── Deleted toast ─────────────────────────────────────────────────── */}
        <StyledModal
          width={190}
          height={70}
          open={isDeletedModalOpen}
          onCancel={() => setIsDeletedModalOpen(false)}
          footer={false}
          closable={false}
          style={{ marginTop: "130px" }}
        >
          <div className="success-modal">
            <Tick />
            <p className="sent-successfully">Deleted</p>
          </div>
        </StyledModal>

        {/* ── Saved toast ───────────────────────────────────────────────────── */}
        <StyledModal
          width={190}
          height={70}
          open={isSavedModalOpen}
          onCancel={() => setIsSavedModalOpen(false)}
          footer={false}
          closable={false}
          style={{ marginTop: "130px" }}
        >
          <div className="success-modal">
            <Tick />
            <p className="sent-successfully">Saved successfully</p>
          </div>
        </StyledModal>

        {/* ── Old image modal (kept for backward compat) ────────────────────── */}
        <Modal
          title={selectedImage ? selectedImage.fileName : "Attachment Preview"}
          open={isModalOpen1}
          onCancel={handleCloseModal}
          footer={null}
          centered
          width={850}
        >
          {selectedImage && selectedImage.fileName?.toLowerCase().endsWith(".pdf") ? (
            <iframe key={selectedImage.fileUrl} src={selectedImage.fileUrl} width="100%" height="500px" style={{ border: "none" }} />
          ) : (
            <img src={selectedImage} alt="Attachment" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
          )}
        </Modal>

        {/* ── Moved success toast ───────────────────────────────────────────── */}
        <Modal open={isSuccessModalVisible} footer={null} centered closable={false} width={200} style={{ height: 150 }}>
          <div style={{ textAlign: "center" }}>
            <Tick />
            <h6>Moved</h6>
          </div>
        </Modal>

        {/* ── File preview modal ────────────────────────────────────────────── */}
        <Modal
          title={selectedFile?.fileName}
          open={isModalVisible1}
          onCancel={handleCloseModal}
          footer={null}
          centered
          width={850}
        >
          {selectedFileUrl &&
            (selectedFile?.fileName?.match(/\.(jpeg|jpg|png|gif|bmp|webp)$/i) ? (
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "500px" }}>
                <img src={selectedFileUrl} alt="Screenshot" style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }} />
              </div>
            ) : (
              <iframe key={selectedFileUrl} src={selectedFileUrl} width="100%" height="500px" style={{ border: "none" }} />
            ))}
        </Modal>
      </Styleddiv>
    </>
  );
}

const mapStateToProps = (state) => ({
  menuList: getMenuList(state),
  userRoleId: getUserRoleId(state),
  clientId: getClientid(state),
  userList: getUserList(state),
  userInfo: getUserInfo(state),
  locationList: getLocations(state),
});

export default connect(mapStateToProps)(ViewDetailsDisciplinary);